import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { LaytEkran } from './LaytEkran';

/**
 * Провайдеры лайта — ровно те, без которых компоненты экрана обращений не живут.
 *
 * ⛔ `BrowserRouter` НУЖЕН, ХОТЯ МАРШРУТОВ У ЛАЙТА НЕТ. Внутри разбора есть
 * ссылка на карточку клиентки — без роутера она бросает исключение и роняет
 * весь экран. Лайт эту ссылку перехватывает и открывает мини-карточку панелью
 * (решение владельца Б), см. `LaytEkran`.
 *
 * ⛔ Словарь (`WordsProvider`) ставится НЕ здесь, а внутри экрана: слова
 * приезжают вместе с ответом сервера, и до первого ответа их попросту нет.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      // Телефон уводят в карман и достают снова десятки раз за смену —
      // перезапрос на возврате фокуса здесь не роскошь, а смысл экрана.
      refetchOnWindowFocus: true,
    },
  },
});

export function LaytApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <LaytEkran />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
